"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.evaluateNormalizedLoanProductConcentrationAndMutateReceivables = exports.createConcentrationLimitMiscAvailableFieldProposals = exports.ConcentrationLimitMiscAvailableFields = exports.checkMultiLoanProductConcentrationCalcsErrors = exports.checkConcentrationCalcsErrors = exports.getAvailableFieldsWithTypes = exports.calculateWeightedAverageConcentrationLimitKickouts = exports.getNormalizedConcentrationLimit = exports.getConcentrationLimitKickouts = exports.calculateStandardConcentrationLimitKickouts = exports.calculateWeightedAverageReceivableKickouts = void 0;
const _ = __importStar(require("lodash"));
const common_1 = require("@finley-technologies/common");
const concentrationLimitValueEvaluator_1 = require("../concentrationLimitValueEvaluator");
const progressHelper_1 = require("../progressHelper");
const waiverEvaluator_1 = require("../waiverEvaluator");
const concentrationLimitFilterFactoryV2_1 = require("./concentrationLimitFilterFactoryV2");
const directInsertByField_1 = require("./directInsertByField");
const groupBySingleField_1 = require("./groupBySingleField");
const standard_1 = require("./standard");
const weightedAverage_1 = require("./weightedAverage");
var weightedAverage_2 = require("./weightedAverage");
Object.defineProperty(exports, "calculateWeightedAverageReceivableKickouts", { enumerable: true, get: function () { return weightedAverage_2.calculateWeightedAverageReceivableKickouts; } });
var standard_2 = require("./standard");
Object.defineProperty(exports, "calculateStandardConcentrationLimitKickouts", { enumerable: true, get: function () { return standard_2.calculateStandardConcentrationLimitKickouts; } });
Object.defineProperty(exports, "getConcentrationLimitKickouts", { enumerable: true, get: function () { return standard_2.getConcentrationLimitKickouts; } });
Object.defineProperty(exports, "getNormalizedConcentrationLimit", { enumerable: true, get: function () { return standard_2.getNormalizedConcentrationLimit; } });
var weightedAverage_3 = require("./weightedAverage");
Object.defineProperty(exports, "calculateWeightedAverageConcentrationLimitKickouts", { enumerable: true, get: function () { return weightedAverage_3.calculateWeightedAverageConcentrationLimitKickouts; } });
var concentrationCalcValidation_1 = require("./concentrationCalcValidation");
Object.defineProperty(exports, "getAvailableFieldsWithTypes", { enumerable: true, get: function () { return concentrationCalcValidation_1.getAvailableFieldsWithTypes; } });
Object.defineProperty(exports, "checkConcentrationCalcsErrors", { enumerable: true, get: function () { return concentrationCalcValidation_1.checkConcentrationCalcsErrors; } });
Object.defineProperty(exports, "checkMultiLoanProductConcentrationCalcsErrors", { enumerable: true, get: function () { return concentrationCalcValidation_1.checkMultiLoanProductConcentrationCalcsErrors; } });
Object.defineProperty(exports, "ConcentrationLimitMiscAvailableFields", { enumerable: true, get: function () { return concentrationCalcValidation_1.ConcentrationLimitMiscAvailableFields; } });
Object.defineProperty(exports, "createConcentrationLimitMiscAvailableFieldProposals", { enumerable: true, get: function () { return concentrationCalcValidation_1.createConcentrationLimitMiscAvailableFieldProposals; } });
// computes exposures considering the concentration limit waivers
const _computeExposures = (concentrationLimitReceivables) => {
    let waivedConcentrationExposure = 0;
    let totalEligibleExposure = 0;
    let totalReceivableValuation = 0;
    const nonGloballyWaivedReceivables = []; // receivables that are not waived by the global requiredIntermediateFields.waiveAllConcentration config in the CA
    for (const clReceivable of concentrationLimitReceivables) {
        const { requiredIntermediateFields, eligibilityFields, valuationFields, } = clReceivable;
        if (requiredIntermediateFields.waiveAllConcentration &&
            !requiredIntermediateFields.includeInConcentrationLimitDenominatorIfWaived) {
            waivedConcentrationExposure += eligibilityFields.eligibleExposure;
        }
        totalEligibleExposure += eligibilityFields.eligibleExposure;
        totalReceivableValuation += valuationFields.valuation;
        if (!requiredIntermediateFields.waiveAllConcentration) {
            nonGloballyWaivedReceivables.push(clReceivable);
        }
    }
    const totalConcentrationExposure = totalEligibleExposure - waivedConcentrationExposure;
    return {
        nonGloballyWaivedReceivables,
        totalConcentrationExposure,
        totalReceivableValuation,
        totalEligibleExposure,
    };
};
const _calculateConcentrationLimitKickouts = ({ config, concentrationReceivables, totalConcentrationExposure, loanTapeMetadata, receivableWaiversForConcentrationLimit, f1EngineMode, }) => {
    const { calculationConfig, propertyKey } = config;
    // If nothing to kickout (0 exposure), then can return early with default 0 values
    if (totalConcentrationExposure === 0) {
        return {
            kickouts: {},
            calculations: {
                concentrationLimitKey: propertyKey,
                concentrationLimit: 0,
                concentration: 0,
                borrowingBaseReduction: 0,
                totalEligibleExposure: 0,
                complianceStatus: 'COMPLIANT',
            },
            individuallyWaivedReceivables: [],
        };
    }
    let kickoutsAndCalculations;
    const { evaluate } = (0, concentrationLimitValueEvaluator_1.createLimitConfigEvaluator)(config, f1EngineMode);
    const oldConfig = evaluate(loanTapeMetadata);
    const filterConfigs = calculationConfig.config.filters || [];
    const filteredReceivables = (0, concentrationLimitFilterFactoryV2_1.executeFilterConfig)({
        configs: filterConfigs ?? [],
        loanTapeRecords: concentrationReceivables,
    });
    // filters typically to choose numerator of concentration limit calculation.
    // but sometimes we also want to apply some of the filters to the denominator as well.
    const denominatorFilterConfigs = filterConfigs.filter((filterConfig) => filterConfig.applyToDenominator);
    if (denominatorFilterConfigs.length > 0) {
        const denominatorFilteredReceivables = (0, concentrationLimitFilterFactoryV2_1.executeFilterConfig)({
            configs: denominatorFilterConfigs,
            loanTapeRecords: concentrationReceivables,
        });
        if (denominatorFilteredReceivables.length !== concentrationReceivables.length) {
            // we are reducing the number of receivables that are included in the denominator
            // totalConcentrationExposure passed to this function assumed that all receivables are included in denominator
            // but since we are filtering out some. we need to reduce the totalConcentrationExposure
            // to only include the receivables that are included in the denominator
            const { totalConcentrationExposure: updatedTotalConcentrationExposure, } = _computeExposures(denominatorFilteredReceivables);
            (0, common_1.debugLog)({
                updatedTotalConcentrationExposure,
                totalConcentrationExposure,
                'denominatorFilteredReceivables.length': denominatorFilteredReceivables.length,
                'concentrationReceivables.length': concentrationReceivables.length,
            });
            // eslint-disable-next-line no-param-reassign
            totalConcentrationExposure = updatedTotalConcentrationExposure;
        }
    }
    // partition the receivables that passed the filterConfig by whether individual receivable waivers exist via receivableBorrowingBaseTestWaivers
    // only include the non-waived receivables in following calculations
    // and make a record of the waived receivables to pass onto the receivable's concentrationLimitWaivers downstream
    const receivableIdsWaivedForConcentrationLimit = new Set();
    receivableWaiversForConcentrationLimit.forEach((waiver) => receivableIdsWaivedForConcentrationLimit.add(waiver.finleyReceivableId));
    const [individuallyWaivedReceivables, nonIndividuallyWaivedReceivables,] = _.partition(filteredReceivables, (filteredReceivable) => {
        return receivableIdsWaivedForConcentrationLimit.has(filteredReceivable.finleyReceivableId);
    });
    switch (calculationConfig.type) {
        case 'weightedAverage':
            kickoutsAndCalculations = (0, weightedAverage_1.calculateWeightedAverageConcentrationLimitKickouts)({
                concentrationLimit: oldConfig.limit,
                field: calculationConfig.config.field,
                concentrationReceivables: nonIndividuallyWaivedReceivables,
                limitType: calculationConfig.limitType,
                weighting: calculationConfig.config.weighting,
                propertyKey,
            });
            break;
        case 'standard':
            kickoutsAndCalculations = (0, standard_1.calculateStandardConcentrationLimitKickouts)({
                concentrationLimit: oldConfig.limit,
                concentrationReceivables: nonIndividuallyWaivedReceivables,
                concentrationLimitValueType: oldConfig.valueType,
                totalConcentrationExposure,
            });
            break;
        case 'exposureByGroup':
            kickoutsAndCalculations = (0, groupBySingleField_1.calculateSingleFieldConcentrationLimitKickouts)({
                concentrationLimit: oldConfig.limit,
                concentrationReceivables: nonIndividuallyWaivedReceivables,
                concentrationLimitValueType: oldConfig.valueType,
                groupingField: calculationConfig.config.groupingField,
                groupingFieldType: calculationConfig.config.fieldType,
                totalConcentrationExposure,
            });
            break;
        case 'directInsert':
            kickoutsAndCalculations = (0, directInsertByField_1.calculateDirectInsertConcentrationLimitKickouts)({
                concentrationLimit: oldConfig.limit,
                concentrationReceivables: nonIndividuallyWaivedReceivables,
                concentrationLimitValueType: oldConfig.valueType,
                kickoutValueField: calculationConfig.config.kickoutValueField,
                totalConcentrationExposure,
            });
            break;
        case 'resolvedPointer': {
            kickoutsAndCalculations = calculationConfig.config.pointerImplementation({
                concentrationReceivables: nonIndividuallyWaivedReceivables,
                valueConfig: oldConfig,
                totalConcentrationExposure,
            });
            break;
        }
        default:
            return (0, common_1.finleyAssertUnreachable)(calculationConfig);
    }
    const { kickouts, calculations } = kickoutsAndCalculations;
    const borrowingBaseReduction = Object.keys(kickouts).reduce((acc, current) => acc + kickouts[current], 0);
    return {
        kickouts,
        calculations: {
            ...calculations,
            borrowingBaseReduction,
            totalEligibleExposure: totalConcentrationExposure,
            concentrationLimitKey: config.propertyKey,
            complianceStatus: borrowingBaseReduction === 0 ? 'COMPLIANT' : 'LIMIT_REACHED',
        },
        individuallyWaivedReceivables,
    };
};
const _evaluateConcentrationLimit = ({ concentrationLimitConfig, concentrationLimitReceivables, loanTapeMetadata, receivableWaiversForConcentrationLimit, f1EngineMode, }) => {
    const { nonGloballyWaivedReceivables, totalConcentrationExposure, totalReceivableValuation, totalEligibleExposure, } = _computeExposures(concentrationLimitReceivables);
    const { kickouts, calculations, individuallyWaivedReceivables, } = _calculateConcentrationLimitKickouts({
        loanTapeMetadata,
        config: concentrationLimitConfig,
        concentrationReceivables: nonGloballyWaivedReceivables, // could still include individually waived receivables, the impact of which we will evaluate in the method
        totalConcentrationExposure,
        receivableWaiversForConcentrationLimit,
        f1EngineMode,
    });
    // check if this concentration is waived by dynamic config in the concentration limit waiveConfigs in the CA, at the per-concentration limit propertyKey level
    const concentrationWaiverEvaluator = (0, waiverEvaluator_1.createWaiveConfigEvaluator)(concentrationLimitConfig.waiveConfigs, f1EngineMode);
    const waiveInputs = {
        loanTapeMetadata,
        receivables: {
            totalReceivableValuation,
            totalEligibleExposure,
        },
    };
    // evaluate waiveReason.
    // even when concentration calcs are waived will  compute the kickouts
    // but will return waiveReason for caller to handle the waiver.
    // this is because caller needs to mark borrowing base reasons to each receivables that
    // were affected.
    const waiveReason = concentrationWaiverEvaluator.evaluate(waiveInputs);
    return { kickouts, calculations, waiveReason, individuallyWaivedReceivables };
};
/**
 * NOTE: this method mutates concentration limit receivables properties
 * as concentration test are run.
 *
 * Concentration limit receivable array can be quite large, and we are already
 * seeing memory / compute time pressure, so we won't make a copy at this time
 */
const evaluateNormalizedLoanProductConcentrationAndMutateReceivables = async ({ concentrationLimitReceivables, normalizedLoanProductConcentrationLimits, loanProductIds, loanTapeMetadata, concentrationKickoutMethod, progressCallback, receivableWaivers, f1EngineMode, }) => {
    // Create LP <> Rec map to easily look up target receivables for specific concentration limits
    const lpIdToReceivablesMap = new Map();
    for (const loanProductId of loanProductIds) {
        lpIdToReceivablesMap.set(loanProductId, []);
    }
    // Populate receivables by ID key and also for LP mapping
    const receivableIdToReceivableMap = new Map();
    for (const receivable of concentrationLimitReceivables) {
        receivableIdToReceivableMap.set(receivable.finleyReceivableId, receivable);
        const lpReceivables = lpIdToReceivablesMap.get(receivable.loanProductId);
        if (lpReceivables) {
            lpReceivables.push(receivable);
        }
        else {
            lpIdToReceivablesMap.set(receivable.loanProductId, [receivable]);
        }
    }
    // Create map that has all associated receivables per loan product ID for each concentration limit,
    // using concentration limit's property key as the index
    const clPropertyKeyToReceivablesMap = new Map();
    for (const multiLpConcLimit of normalizedLoanProductConcentrationLimits) {
        const { propertyKey } = multiLpConcLimit;
        const targetReceivables = [];
        for (const loanProductId of multiLpConcLimit.loanProductIds) {
            const receivables = lpIdToReceivablesMap.get(loanProductId);
            (0, common_1.finleyAssert)(receivables, `Failed to retrieve receivables associated with loan product [loanProductId:${loanProductId}] [propertyKey:${propertyKey}]`);
            for (const receivable of receivables) {
                targetReceivables.push(receivable);
            }
        }
        clPropertyKeyToReceivablesMap.set(propertyKey, targetReceivables);
    }
    // Apply concentration limit in order, reducing "eligibleExposureLessConcentrationLimitKickouts" per step
    const concentrationCalculations = [];
    const aggregateKickouts = {};
    const numConfigs = normalizedLoanProductConcentrationLimits.length;
    // we loop through (instead of map) to ensure callback gets called sequentially.
    const { updateProgress } = (0, progressHelper_1.createProgressHelper)({
        progressCallback,
        operation: 'Evaluate concentration limit criteria',
        numRows: numConfigs,
    });
    const concentrationWaiversForPropertyKeys = {};
    receivableWaivers.forEach((waiver) => {
        if (waiver.borrowingBaseTestType === 'concentration') {
            if (!concentrationWaiversForPropertyKeys[waiver.borrowingBaseTestKey]) {
                concentrationWaiversForPropertyKeys[waiver.borrowingBaseTestKey] = [];
            }
            concentrationWaiversForPropertyKeys[waiver.borrowingBaseTestKey].push(waiver);
        }
    });
    // eslint-disable-next-line no-restricted-syntax, no-plusplus
    for (let idx = 0; idx < numConfigs; idx++) {
        const concentrationLimit = normalizedLoanProductConcentrationLimits[idx];
        const { propertyKey } = concentrationLimit;
        // eslint-disable-next-line no-await-in-loop
        await updateProgress(idx, `Processing: ${propertyKey}`);
        // These target receivables will already be filtered by CL's associated loan product IDs
        const targetClReceivables = clPropertyKeyToReceivablesMap.get(propertyKey);
        (0, common_1.finleyAssert)(targetClReceivables, `Failed to retrieve receivables from map [propertyKey:${propertyKey}]`);
        const receivableWaiversForConcentrationLimit = concentrationWaiversForPropertyKeys[propertyKey] ?? [];
        const { kickouts, calculations, waiveReason, individuallyWaivedReceivables, } = _evaluateConcentrationLimit({
            concentrationLimitConfig: concentrationLimit,
            concentrationLimitReceivables: targetClReceivables,
            loanTapeMetadata,
            receivableWaiversForConcentrationLimit,
            f1EngineMode,
        });
        for (const entry of Object.entries(kickouts)) {
            const [finleyReceivableId, concentrationLimitKickout] = entry;
            if (concentrationLimitKickout === 0) {
                continue;
            }
            const concentrationLimitReceivable = receivableIdToReceivableMap.get(finleyReceivableId);
            (0, common_1.finleyAssert)(concentrationLimitReceivable, `concentrationLimitReceivable must exist [receivableId:${finleyReceivableId}]`);
            if (waiveReason) {
                // NOTE: We only record global waivers here (and set compliance status)
                // When writing to datalake, if a receivable is individually waived, we appropriately set compliance status
                // for individual receivable, and add 'individualWaiver' to waiverReason list
                calculations.complianceStatus = 'WAIVED';
                calculations.borrowingBaseReduction = 0;
                concentrationLimitReceivable.concentrationLimitWaivers.push({
                    propertyKey,
                    waiveReason,
                    waivedAmount: concentrationLimitKickout,
                });
            }
            else {
                // If utilizing Waterfall methodology, update eligible exposure (numerator) for next round of kickouts.
                // Otherwise, leave as gross base amount (initial eligible exposure) and only adjust after all calcs are done
                if (concentrationKickoutMethod === 'waterfall') {
                    concentrationLimitReceivable.concentrationLimitFields.eligibleExposureLessConcentrationLimitKickouts -= concentrationLimitKickout;
                }
                if (!(finleyReceivableId in aggregateKickouts)) {
                    aggregateKickouts[finleyReceivableId] = 0;
                }
                aggregateKickouts[finleyReceivableId] += concentrationLimitKickout;
                concentrationLimitReceivable.concentrationLimitReasons.push({
                    propertyKey,
                    concentrationLimitKickout,
                });
            }
        }
        individuallyWaivedReceivables.forEach((waivedReceivable) => {
            const concentrationLimitReceivable = receivableIdToReceivableMap.get(waivedReceivable.finleyReceivableId);
            (0, common_1.finleyAssert)(concentrationLimitReceivable, `concentrationLimitReceivable must exist [receivableId:${waivedReceivable.finleyReceivableId}]`);
            // record individually-waived receivables that are waived by receivableBorrowingBaseTestWaivers
            concentrationLimitReceivable.concentrationLimitWaivers.push({
                propertyKey,
                waiveReason: 'individualWaiver',
            });
        });
        concentrationCalculations.push(calculations);
    }
    // If utilizing "nonIterative" method, receivables' exposures haven't been adjusted yet for concentration limit calculations.
    // This adjusts the exposure based on the aggregate kickouts that were all based on the initial eligible exposure
    if (concentrationKickoutMethod === 'nonIterative') {
        for (const receivable of concentrationLimitReceivables) {
            const totalKickouts = aggregateKickouts[receivable.finleyReceivableId];
            if (!totalKickouts) {
                continue;
            }
            // Note: this is currently allowing receivables to potentially have negative exposure since nonIterative kickouts
            // can continually stack on top of one another. We may need to come back and revisit this once we have a
            // more defined methodology of handling these types of scenarios (generally should be rare)
            receivable.concentrationLimitFields.eligibleExposureLessConcentrationLimitKickouts -= totalKickouts;
        }
    }
    // Recall that "concentrationLimitReceivables" have been mutated / updated throughout this function as well
    return concentrationCalculations;
};
exports.evaluateNormalizedLoanProductConcentrationAndMutateReceivables = evaluateNormalizedLoanProductConcentrationAndMutateReceivables;
//# sourceMappingURL=index.js.map